<template>
  <BaseCard no-padding>
    <div class="tw:flex">
      <div class="tw:w-1/2 tw:bg-blue-300 tw:rounded-l-xl tw:flex tw:justify-center tw:items-center">
        <img src="@/assets/img/rate-connect/rc-no-data.svg" alt="roomtypes" class="tw:w-[230px] tw:py-28" />
      </div>

      <div class="tw:w-1/2 tw:flex tw:justify-center tw:flex-col tw:px-12">
        <h1 class="tw:text-header-big tw:font-bold tw:pb-10">
          {{ $t('rc_error_message_header') }}
        </h1>
        <p class="tw:text-xl">{{ $t('rc_error_message_text') }}</p>
      </div>
    </div>
  </BaseCard>
</template>
<script setup>
import BaseCard from '@/components/dashboard/BaseCard.vue'
</script>
